import { Route, Routes, useLocation } from "react-router-dom";
import { CoachingRouteScreen } from "./coaching-route-screen";
import { getRouteById } from "../domain/capabilities";
import { routeManifest } from "./route-manifest";

const dashboardRoute = getRouteById("dashboard");

export function CoachingRoutes() {
  // Keying every screen on location.key remounts the route surface per navigation,
  // matching the full-page-load semantics of the retired window.location router.
  const location = useLocation();

  return (
    <Routes>
      <Route element={<CoachingRouteScreen key={location.key} route={dashboardRoute} />} path="/" />
      {routeManifest.map((route) => (
        <Route
          caseSensitive
          element={<CoachingRouteScreen key={location.key} route={route} />}
          key={route.id}
          path={route.path}
        />
      ))}
      <Route element={<CoachingRouteScreen key={location.key} route={null} />} path="*" />
    </Routes>
  );
}
